import { Button, Form, Input, Table, message, Row, Col, Space, Popconfirm } from "antd";
import { serverFetch } from "../../server";
import { useState, useEffect } from "react";
import { fmtDate } from "../../extensions/utils";
import { getTableColumn } from "../../extensions/helper";
import { DownOutlined, RightOutlined } from "@ant-design/icons";
import ClientAbonUsageChange from "./client-abon-usage-change";
import { isMobile } from "../../extensions/design";

const ClientAbonPackageChange = ({ pack, onAbonsUpdate, onClose }) => {
const [form] = Form.useForm();
const [loading, setLoading] = useState(false);
const [packageItem, setPackageItem] = useState(pack);
const [usageItems, setUsageItems] = useState();
const [selectedId, setSelectedId] = useState(null);
const [product, setProduct] = useState(null);
const [selectedUsage, setSelectedUsage] = useState(null);

  const getProduct = (productId) => {
    if (!productId) {
      setProduct(null);
      return;
    }
    serverFetch(`product/${productId}`)
      .then((data) => setProduct(data))
      .catch((e) => message.error(e.userMessage));
  };
  const onSave = () => {
    setLoading(true);
      serverFetch("sale/ProductUpdate", {method: "PUT", bodyData: packageItem})
        .then(() => {
          onClose(true)
          setLoading(false);
        })
        .catch(e => {
          setLoading(false);
          message.error(e.userMessage);
        })
  }

  const onDelete = () => {
    setLoading(true);
      serverFetch(`sale/ProductDelete/${pack.id}`, {method: "DELETE"})
        .then(() => {
          onClose(true)
          setLoading(false);
        })
        .catch(e => {
          setLoading(false);
          message.error(e.userMessage);
        })
  };

  const onCancel = () => { onClose() };

  const getUsageData = () => {
    setLoading(true);
    serverFetch(`sale/UseListBySaleProduct/${pack.id}`)
      .then((data) => {
        setUsageItems(data);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage || "Ошибка загрузки");
      });
  };
  useEffect(() => { 
    getUsageData();
  }, []);
  
  useEffect(() => {
    form.setFieldsValue(pack);
    setPackageItem(pack);
    getProduct(pack?.productId);
  }, [pack]);

  const onValuesChange = value => setPackageItem({...packageItem, ...value});

  const handleClose = (refresh) => {
    setSelectedId(null);
    refresh ? getUsageData() : setUsageItems([...usageItems.filter(i => i.id !== 0)]);
    refresh && onClose(true)
    refresh && onAbonsUpdate();
  };

  const handleMobileClose = (refresh) => {
    if (refresh) {
      getUsageData();
      onAbonsUpdate();
    } else {
      setUsageItems([...usageItems.filter(i => i.id !== 0)]);
    }
  };

  const onRowClick = record => setSelectedId(record.id === selectedId ? null : record.id);

  const usageColumns = [
    getTableColumn("useDate", "Дата", { type: "date", width: 25, formatFn: fmtDate }),
    getTableColumn("visitId", "Визит", { type: "number", width: 25 }),
    getTableColumn("userName", "Исполнитель"),
    getTableColumn("qty", "Количество", { type: "number", width: 25 }),
  ];
  const content = !isMobile ? <>
    <Form form={form} colon={false} labelCol={{ span: 5 }} wrapperCol={{ span: 24 }} loading={loading} onValuesChange={onValuesChange}>
      <Row style={{marginTop:"8px"}}>
        <Col span={10}>
          <Form.Item label="Продано" name="qty" labelCol={{ span: 12 }} wrapperCol={{ span: 12 }}><Input disabled={product?.vid === 1}/></Form.Item>
        </Col>
        <Col span={11}>
          <Form.Item label="Корректировка" name="initialUseQty" labelCol={{ span: 12 }} wrapperCol={{ span: 12 }}><Input/></Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={10}>
          <Form.Item label="Остаток" name="qtyRest" labelCol={{ span: 12 }} wrapperCol={{ span: 12 }}><Input disabled/></Form.Item>
        </Col>
        <Col span={11}>
          <Form.Item label="Использовано" name="qtyUse" labelCol={{ span: 12 }} wrapperCol={{ span: 12 }}><Input disabled/></Form.Item>
        </Col>
      </Row>
      <Row>
        <Form.Item label=" " labelCol={{ span: 22 }} style={{marginTop:"16px", marginBottom:"16px"}}>
          <Space>
            <Popconfirm title="Подтверждение" description="Удалить пакет?" onConfirm={onDelete}>
              <Button>Удалить</Button>
            </Popconfirm>
            <Button onClick={onSave}>Сохранить</Button>
            <Button onClick={onCancel}>Отмена</Button>
          </Space>
        </Form.Item>
      </Row>

      <Table dataSource={usageItems} loading={loading} columns={usageColumns} rowKey="id" size="small" className="table-detail"
        pagination={false}
          expandable={{
            expandedRowRender: record => <ClientAbonUsageChange usage={record} onClose={handleClose} />,
            expandedRowKeys: selectedId != null ? [selectedId] : [],

            onExpand: (expanded, record) => setSelectedId(expanded ? record.id : null),
            expandIcon: ({ expanded, onExpand, record }) => expanded ? <DownOutlined onClick={(e) => onExpand(record, e)} /> : <RightOutlined onClick={(e) => onExpand(record, e)} />,
            expandIconColumnIndex: usageColumns.length + 1,
            rowExpandable: () => true,
            className: "cl-abons-expandable",
          }}
          onRow={(record) => ({ onClick: () => onRowClick(record) })}
          rowSelection={{ type: 'radio', selectedRowKeys: selectedId != null ? [selectedId] : [], renderCell: (checked) => ( 
              <div className={checked ? "list-indicator" : ""} /> 
            ),
          }}
        />
    </Form>
  </> : <>
    <Form form={form} colon={false} labelCol={{ flex: "65px" }} wrapperCol={{ flex: "1" }} loading={loading} onValuesChange={onValuesChange} className="client-subitem-content">
      <div className="client-item-line-double-halfed">
        <Form.Item label="Прод." name="qty"><Input className="client-abon-form-item" disabled={product?.vid === 1}/></Form.Item>
        <Form.Item label="Остат." name="qtyRest"><Input className="client-abon-form-item" disabled/></Form.Item>
      </div>
      <div className="client-item-line-double-halfed">
      <Form.Item label="Использ." name="qtyUse"><Input className="client-abon-form-item" disabled/></Form.Item>
      <Form.Item label="Коррект." name="initialUseQty"><Input className="client-abon-form-item"/></Form.Item>
      </div>
      <div className="client-item-line-triple-halfed" style={{marginBottom:"8px"}}>
        <Popconfirm title="Подтверждение" description="Удалить пакет?" onConfirm={onDelete}
            placement="top" getPopupContainer={(trigger) => trigger.closest('.client-item-line-double-halfed')} overlayClassName="centered-popconfirm">
              <Button>Удалить</Button>
        </Popconfirm>
        <Button onClick={onSave}>Сохранить</Button>
        <Button onClick={onCancel}>Отмена</Button>
      </div>
      <>{usageItems?.map(item => {
        const isOpen = selectedId === item.id;
        return (
        <div key={item.id}>
          <div style={{ cursor: "pointer" }} onClick={() => setSelectedId(isOpen ? null : item.id)}>
            <div className={ selectedId === item.id ? "client-subitem-selected" : "client-subitem"}>
              <div className="client-item-body">
                <div className="client-item-line-bold-double">
                  <div className="client-item-clip">{fmtDate(item.useDate)}</div>
                  <div className="client-item-clip-right">Списано: {item.qty}</div>
                </div>
                <div className="client-item-line-single">
                  <div className="client-item-clip">Пользователь: {item.userName}</div>
                </div>
              </div>
              {isOpen && (
                <div onClick={(e) => e.stopPropagation()}>
                  <ClientAbonUsageChange
                    usage={item}
                    onClose={handleMobileClose}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        )})}
      </>

    </Form>
  </>
  return (
    <>
      {content}
    </>
  );
};
export default ClientAbonPackageChange;
